import JobseekerEmployment from './jobseekerEmployment';
import JobseekerEducation from './jobseekerEducation';
import JobseekerProject from './jobseekerProject';
import JobseekerPersonalDetails from './jobseekerPersonalDetails';
import JobseekerLanguages from './jobseekerLanguages';
import JobseekerCareerProfile from './jobseekerCareerProfile';
import JobseekerAttachments from './jobseekerAttachments';
import JobseekerConditionalQuestions from './jobseekerConditionalQuestions';
import JobseekerConditionalQuestionsTemp from './jobseekerConditionalQuestionsTemp';
import JobseekerCareerProfileTemp from './jobseekerCareerProfileTemp';
import JobseekerPersonalDetailsTemp from './jobseekerPersonalDetailsTemp';
import JobseekerEducationsTemp from './jobseekerEducationsTemp';
import JobseekerEmploymentsTemp from './jobseekerEmploymentsTemp';

export default class Jobseeker {
    constructor(
        public candidateName: string = null,
        public firstName: string = null,
        public lastName: string = null,
        public address: string = null,
        public postcode: string = null,
        public city: string = null,
        public state: string = null,
        public email: string = null,
        public password: string = null,
        public confirmPassword: string = null,
        public mobileNumber: string = null,
        public icNumber: string = null,
        public totalWorkExperienceInYrs: number = null,
        public totalWorkExperienceInMonths: number = null,
        public resumeFileName: string = null,
        public resumeBaseTxt: string = null,
        public profilePicName: string = '',
        public profilePicBaseTxt: string = '',
        public fresher: string = null,
        public termsAndConditions: string = null,
        public currentLocation: string = null,
        public currentCountry: string = null,
        public country: string = null,
        public telephoneNoCountryCode: string = null,
        public telephoneNoAreaCode: string = null,
        public telephoneNo: string = null,
        public resumeHeadLine: string = '',
        public desiredJobType: string = null,
        public desiredEmploymentType: string = null,
        public gender: string = null,
        public profileSummary: string = '',
        public status: string = null,
        public keySkills: string = null,
        public salaryType: string = null,
        public annualSalaryInMillion: string = null,
        public annualSalaryInThousand: string = null,
        public createdAt: Date = null,
        public updatedAt: Date = null,
        public mailToken: string = null,
        public roleType: string = null,
        public employerId: number = null,
        public employerReferenceId:number = null,
        public courseStatus:string = null,
        public currentStatus:string = null,
        public courseId:number = null,
        public jobseekerEmployments?: JobseekerEmployment[],
        public jobseekerEducations?: JobseekerEducation[],
        public jobseekerProject?: JobseekerProject[],
        public jobseekerLanguages?: JobseekerLanguages[],
        public jobseekerEmploymentsTemp: JobseekerEmploymentsTemp[] = [],
        public jobseekerEducationsTemp: JobseekerEducationsTemp[] = [],
        public jobseekerProjectTemp: JobseekerProject[] = [],
        public jobseekerCareerProfileTemp: JobseekerCareerProfileTemp[] = [],
        public jobseekerPersonalDetails?: JobseekerPersonalDetails[],
        public jobseekerPersonalDetailsTemp: JobseekerPersonalDetailsTemp[] = [],
        public jobseekerCareerProfile?: JobseekerCareerProfile[],
        public jobseekerAttachments?: JobseekerAttachments[],
        public jobseekerLanguagesTemp: JobseekerLanguages[] =[],
        public jobseekerConditionalQuestionsTemp: JobseekerConditionalQuestionsTemp[] =[],
        public jobseekerConditionalQuestions?: JobseekerConditionalQuestions[],
        public provider: string = null,
        public lastLoginAt: Date = null,
        public retrenched_flag:number = null,
        /**Add on for CR2 */
        public alternativeMobileIntlCode:string ='+60',
        public alternativeMobileNumber:string='',
        public alternativeEmail:string=null,
        public passportNumber:string=null,
        public ageCategory:string=null,
        public nationality:string=null,
        public typeOfOrganization:string=null,
        public dob:string=null,
        public typeOfEmployment:string=null,
        public mobileIntlCode:string= '+60',
        public otherCountry:string=null,
        
    ) {

    }
}